export { default as DefaultPage } from './DefaultPage';
export { default as PassengerDetailsBlock } from './PassengerDetailsBlock';
export { default as CancellationPolicyBlock } from './CancellationPolicyBlock';
export { default as RefundDetailsBlock } from './RefundDetailsBlock';
export { default as FailedCancellation } from './FailedCancellation';
export { default as FailTransaction } from './FailTransaction';



// WEBPACK FOOTER //
// ./src/features/cancellation/index.js